/* const serverURL = 'http://localhost:5004' */
const serverURL = 'https://serverplaneta-arena.deltabyte.com.br'

export default serverURL
